import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { LibroCompraVentaRoutingModule } from './libro-compra-venta-routing.module';
import { LibroCompraVentaComponent } from './main/libro-compra-venta.component';
import { LcvApiService } from './services/lcv-api.service';
import { TotalizerTilesComponent } from './components/totalizer-tiles/totalizer-tiles.component';
import { LcvEvColumnChartComponent } from './components/lcv-ev-column-chart/lcv-ev-column-chart.component'
import { NgApexchartsModule } from 'ng-apexcharts';
import { LcvByPropertyChartsComponent } from './components/lcv-by-property-charts/lcv-by-property-charts.component';
import { LcvStatsComponent } from './components/lcv-stats/lcv-stats.component';
import { LcvProveedoresTableComponent } from './components/lcv-proveedores-table/lcv-proveedores-table.component';
import { LcvTop10Component } from './components/lcv-top10/lcv-top10.component';
import { LcvEvByEntityComponent } from './components/lcv-ev-by-entity/lcv-ev-by-entity.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { LcvCardsContainerComponent } from './containers/lcv-cards-container/lcv-cards-container.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';


@NgModule({
  declarations: [
    LibroCompraVentaComponent,
    TotalizerTilesComponent,
    LcvEvColumnChartComponent,
    LcvByPropertyChartsComponent,
    LcvStatsComponent,
    LcvProveedoresTableComponent,
    LcvTop10Component,
    LcvEvByEntityComponent,
    LcvCardsContainerComponent,
  ],
  imports: [
    CommonModule,
    LibroCompraVentaRoutingModule,
    MatButtonToggleModule,
    NgApexchartsModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSelectModule,
    SharedComponentsModule
  ],
  // providers: [
  //   LcvApiService,
  //   { 
  //     provide: HIGHCHARTS_MODULES, 
  //     useFactory: () => [Highcharts] 
  //   }
  // ]
})
export class LibroCompraVentaModule { }
